module.exports = __webpack_public_path__ + "img/04.3b3a69ce.png";